import axios from "axios";
import React, { useEffect } from "react";
import get_token from "../lib/get_token";
import { configState } from "../lib/State";

// 두써킷 센타앱 회원은 HR 쪽으로 회원데이타 복사
function HomeHrSync(props) {
  const { login } = props;
  const init = async () => {
    let postData = {
      token: get_token(),
      cid: configState.cid,
      mcd: login.mcd,
      level: login.level,
    };
    let result = await axios.post(configState.api+"/hr/home_hr_sync", postData);
  };
  useEffect(() => {
    if (login.mcd !== "") {
      init();
    }
  }, [login]);

  return null;
}
export default HomeHrSync;
